// TODO remove this after we resolve the translatepress anchore not getting recognized on PROD issue
jQuery(document).ready(function( $ ) {

  var ww = $('#whitepaper-workaround');
  $('#whitepaper-workaround').remove();

  $('.dappx-whitepaper').append( ww );

});